export default class PixiTop {
  constructor() {
    this.nrwBP = 768;
    this.displacementImage =
      "/wp/wp-content/themes/blue1993/assets/img/pixi/clouds.jpg";
    this.SpriteImg = [
      "/wp/wp-content/themes/blue1993/assets/img/pixi/main_ph.jpg",
    ];
    this.autoPlaySpeed = window.innerWidth <= this.nrwBP ? [2, 2] : [1, 1];

    this.renderer = new PIXI.autoDetectRenderer(1920, 1080, {
      transparent: true,
    });
    this.stage = new PIXI.Container();
    this.slidesContainer = new PIXI.Container();
    this.displacementSprite = new PIXI.Sprite.fromImage(this.displacementImage);
    this.displacementFilter = new PIXI.filters.DisplacementFilter(
      this.displacementSprite
    );
    this.image = "";
    this.vx = 1;
    this.ease = 0.2;

    this.init();
  }

  init() {
    this.initPixi();
    this.loadPixiSprites(this.SpriteImg);
    this.ticker();
  }

  ticker() {
    var ticker = new PIXI.ticker.Ticker();
    var that = this;

    ticker.autoStart = true;

    ticker.add(function (delta) {
      that.displacementSprite.x += that.autoPlaySpeed[0];
      that.displacementSprite.y += that.autoPlaySpeed[1];
      //that.pan_x();
      that.renderer.render(that.stage);
    });
  }

  pan_x() {
    if (this.nrwBP <= window.innerWidth) {
      this.image.x = 0;
      return;
    }

    this.image.x += this.vx * this.ease;

    var limit_x = (1920 - window.innerWidth) / 2.3;
    if (this.image.x >= limit_x || this.image.x <= -limit_x) {
      this.vx *= -1;
    }
  }

  initPixi() {
    // Add canvas to the HTML
    document.body.insertBefore(this.renderer.view, document.body.firstChild);

    // Add child container to the main container
    this.stage.addChild(this.slidesContainer);

    // Enable Interactions
    this.stage.interactive = true;

    this.renderer.view.style.objectFit = "cover";
    //this.renderer.view.style.width = '100%';
    //this.renderer.view.style.height = '100%';
    //this.renderer.view.style.top = '50%';
    //this.renderer.view.style.left = '50%';
    //this.renderer.view.style.webkitTransform = 'translate( -50%, -50% )';
    //this.renderer.view.style.transform = 'translate( -50%, -50% )';

    this.displacementSprite.texture.baseTexture.wrapMode =
      PIXI.WRAP_MODES.REPEAT;

    // Set the filter to stage and set some default values for the animation
    this.stage.filters = [this.displacementFilter];

    this.displacementSprite.scale.x = 2;
    this.displacementSprite.scale.y = 2;

    // PIXI tries to fit the filter bounding box to the renderer so we optionally bypass
    //displacementFilter.autoFit = options.displaceAutoFit;

    this.stage.addChild(this.displacementSprite);
  }

  loadPixiSprites(sprites) {
    //テクスチャーとして保存
    for (var i = 0; i < sprites.length; i++) {
      var texture = new PIXI.Texture.fromImage(sprites[i]);
      var image = new PIXI.Sprite(texture);

      this.slidesContainer.addChild(image);
      this.image = image;
    }
  }
}
